export function getSampleImageUrl(url: string) {
  return `${url}?$format_a$`;
}
